import { render } from "./RegistrationDashboardView.vue?vue&type=template&id=933adba2"
import script from "./RegistrationDashboardView.vue?vue&type=script&lang=js"
export * from "./RegistrationDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__